// extracted by mini-css-extract-plugin
export default {"wrapper":"JuiW5","orderBtn":"b2JaS"};